<div class="results-container">
  <div class="section-header-results">
    <h2 class="section-title-h2">{{guideComponent()?.title}} {{GUIA_KEY}}</h2>
    <p class="section-description-results">
      {{guideComponent()?.description}}
    </p>
    <hr />
    <div class="container-btn">
      <button type="button" (click)="handleGoBack()">{{guideComponent()?.backButton}}</button>
    </div>
  </div>

  <div class="total-score-section">
    <h3 class="section-title">{{ guideComponent()?.sectionTitle }}</h3>
    <p class="total-score">{{ guideComponent()?.totalScoreLabel }} <span>{{ totalSum }} pts</span></p>
    <p class="evaluation-result"> {{ guideComponent()?.evaluationResultsLabel }} <span class="evaluation-badge" [attr.data-level]="finalEvaluation"> {{ finalEvaluation }}</span> </p>
    <p class="score-explanation">
      {{ guideComponent()?.scoreExplanationLabel }}
    </p>

    @if(GUIA_KEY !== "GUIA I"){
      <div class="div-totals">
        <p class="total"> {{ guideComponent()?.totalCategoryLabel }} <span>{{ totalSum}} pts</span> </p>
        <p class="total"> {{ guideComponent()?.totalDomainLabel }} <span>{{ totalSum }} pts</span> </p>
        <p class="total"> {{ guideComponent()?.totalDimensionLabel }} <span>{{ totalSum }} pts</span></p>
        <p class="score-explanation">
          {{ guideComponent()?.scoreExplanation }}
        </p>
      </div>
    }
  </div>

  @if(GUIA_KEY !== "GUIA I"){
    <div  class="results-table-container">
      <!--      <h3 class="section-title">Tabla de resultados detallados</h3>-->
      <div class="table-responsive">
        <table class="results-table desktop-table">
          <thead>
          <tr>
            <th>Pregunta</th>
            <th>Categoría</th>
            <th>Dominio</th>
            <th>Dimensión</th>
            <th>Valor</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
            @for(row of data; track row.questionId){
              <tr >
                <td>{{ row.text }}</td>
                <td>{{ row.category }}</td>
                <td>{{ row.domain }}</td>
                <td>{{ row.dimension }}</td>
                <td>{{ row.score }}</td>
                <td></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <!-- Vista tipo tarjeta para móviles -->
    <div class="mobile-cards">
      @for(row of data; track row.questionId){
        <div class="card">
          <div class="card-row">
            <span class="label">Pregunta:</span>
            <span class="value">{{ row.text }}</span>
          </div>
          <div class="card-row">
            <span class="label">Categoría:</span>
            <span class="value">{{ row.category }}</span>
          </div>
          <div class="card-row">
            <span class="label">Dominio:</span>
            <span class="value">{{ row.domain }}</span>
          </div>
          <div class="card-row">
            <span class="label">Dimensión:</span>
            <span class="value">{{ row.dimension }}</span>
          </div>
          <div class="card-row">
            <span class="label">Valor:</span>
            <span class="value">{{ row.score }}</span>
          </div>
        </div>
      }
    </div>

  }

  <div class="summary-section">
    <!-- Resumen por Categoría -->
    @if (GUIA_KEY !== "GUIA I") {
      <h3 class="section-title-results">Resumen por categoría</h3>
      <div class="summary-table-container">
        <table class="summary-table">
          <thead>
          <tr>
            <th class="category-column">Categoría</th>
            <th class="value-column">Valor</th>
            <th class="evaluation-column">Nivel de riesgo</th>
          </tr>
          </thead>
          <tbody>
            @for(category of categoryTotalsArray; track category){
              <tr>
                <td class="category-column">{{ category.key }}</td>
                <td class="value-column">{{ category.value }}</td>
                <td class="evaluation-column">
                  @if(categoryEvaluations[category.key]){
                    <span
                      class="evaluation-badge"
                      [attr.data-level]="categoryEvaluations[category.key]"
                    >
                      {{ categoryEvaluations[category.key] }}
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <!-- Resumen por Dominio -->
    @if (GUIA_KEY !== "GUIA I") {
      <h3 class="section-title-results">Resumen por dominio</h3>
      <div class="summary-table-container">
        <table class="summary-table">
          <thead>
          <tr>
            <th class="category-column">Dominio</th>
            <th class="value-column">Valor</th>
            <th class="evaluation-column">Nivel de riesgo</th>
          </tr>
          </thead>
          <tbody>
            @for(domain of domainTotalsArray; track domain){
              <tr>
                <td class="category-column">{{ domain.key }}</td>
                <td class="value-column">{{ domain.value }}</td>
                <td class="evaluation-column">
                  @if(domainEvaluations[domain.key]){
                    <span class="evaluation-badge" [attr.data-level]="domainEvaluations[domain.key]">
                      {{ domainEvaluations[domain.key] }}
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <!-- Resumen por Dimensión -->
    <h3 class="section-title-results">Resumen por dimensión</h3>
    <div class="summary-table-container">
      <table class="summary-table dimension-table">
        <thead>
        <tr>
          <th class="category-column">Dimensión</th>
          <th class="value-column">Valor</th>
        </tr>
        </thead>
        <tbody>
          @for (dim of dimensionTotalsArray; track dim){
            <tr >
              <td class="category-column">{{dim.key }}</td>
              <td class="value-column">{{ dim.value }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
